import { useEffect } from 'react'

window.nachnamen = window.nachnamen || {}

// const url='https://interaktiv.tagesanzeiger.ch/2025/nachnamen/verzeichnis.json'
const url='https://interaktiv-mf.tagesanzeiger.ch/2026/etl-nachnamen/verzeichnis.json'
export const LoadVerzeichnis = () => {
  useEffect(() => {
    if (window.nachnamen.verzeichnis) return
    fetch(
      url
    )
      .then((d) => d.json())
      .then((d) => {
        console.log("verzeichnis loaded", d)
        var objs = d.map((m: (string | number)[]) => ({
          name: m[0],
          id: m[4],
          incollection: m[3],
          abs: m[1],
          rel: m[2],
        }))
        window.nachnamen.verzeichnis = objs
        console.log('dispatching event', objs)
        const event = new Event('verzeichnis_loaded')
        window.dispatchEvent(event)
      })
  }, [])
  return null
}
